import { createTheme } from "@mui/material";

// Create base Material UI theme
export const createMuiTheme = (isDarkMode = false) => createTheme({
  palette: {
    mode: isDarkMode ? 'dark' : 'light',
    primary: {
      main: '#2196F3',
      light: '#64B5F6',
      dark: '#1976D2',
    },
    secondary: {
      main: '#f50057',
    },
    background: {
      default: isDarkMode ? '#121212' : '#fafafa',
      paper: isDarkMode ? '#1e1e1e' : '#ffffff',
    },
  },
  typography: {
    fontFamily: 'IBM Plex Sans, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
    h4: {
      fontSize: { xs: '1.5rem', sm: '2.125rem' }
    },
    h5: {
      fontSize: { xs: '1.25rem', sm: '1.5rem' }
    },
    h6: {
      fontSize: { xs: '1rem', sm: '1.25rem' }
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          minHeight: 44, // Touch-friendly height
          fontSize: { xs: '0.875rem', sm: '0.875rem' },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          minWidth: 44,
          minHeight: 44, // Touch-friendly size
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 48, // Touch-friendly tabs
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 48,
          fontSize: { xs: '0.75rem', sm: '0.875rem' },
        },
      },
    },
  },
})